<!--zylc.vue  住院流程-->
<template>
  <div class="zylc-all-box">
    <div class="img-box">
      <img src="~@/assets/images/serviceGuide/zylc.png" width="100%" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Zylc',
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.zylc-all-box {
  background-color: #FFFFFF;
  padding: 10px 20px;
}
.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
